import { createErrorHandler } from "./handling-errors-base";
import { errorMessages } from "./handling-enrollment-errors-helpers";
import { APP_ENVIRONMENT, BASE_ENROLLMENTS_URL } from "./index";
import { requestGetWithTemplate } from "./service-request-template";
import { GA_EVENTS } from "./tracker/ga.types";
import { EnrollmentStatusEntity } from "./types/enrollments.entity";

const handlingUserIdEnrollmentErrors = createErrorHandler({
  ...errorMessages,
}, (status) => (status === 423 ? "" : "Paso1_Landing - "));

export const getEnrollmentStatusByUserIdService = async ({
  userId,
}: {
  userId: string;
}) => {
  return requestGetWithTemplate<EnrollmentStatusEntity>({
    url: `${BASE_ENROLLMENTS_URL}enrollments?userId=${userId}`,
    errorUrl: `in the get /api/v1/enrollments?userId=${userId}`,
    onHttpErrorMessage: "Error in the get enrollments by userId",
    onUnknownErrorLogMessage: `Paso1_Landing - Unknown error in the get /api/v1/enrollments?userId=${userId}`,
    emptyData: {} as EnrollmentStatusEntity,
    handleError: handlingUserIdEnrollmentErrors,
    errorEventName: (status) =>
      status === 423
        ? GA_EVENTS.ERRORS.ENROLLMENT_USER_BLOCKED
        : GA_EVENTS.ERRORS.REQUEST_ENROLLMENT_REQUEST_CREATE_ONBOARDING_LANDING,
    successStatuses: [200],
    additionalHeaders: { clientId: APP_ENVIRONMENT },
  });
};
